import { AppSettings } from "@/settings"

import { internalCustomerException } from "../../customer/utils/customerQueryHelpers"
import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getEmployeeReference } from "../../shared/utils/getEmployeeReference"
import {
  getApplicationReferences,
  getAttachmentReferences,
  getClaimReferences,
  getDefectReferences,
} from "../utils/complaintHelpers"

/**
 * Method to create the complaint
 */
export const mutationCreateComplaint = {
  async createComplaint(_parent, args, context, _info) {
    const { customerNumber, customerId, values, cdn, lang } = args
    const { user } = context
    const todaysDate = new Date().toISOString()

    if (!customerNumber && !customerId) {
      throw new Error("Customer number or customer id is missing")
    }

    await Promise.all([
      checkPermissions({
        user,
        domainObject: DomainObjects.COMPLAINTS,
        operation: Operations.CREATE,
      }),
      internalCustomerException({ id: customerId, customerNumber }),
    ])

    if (!values) {
      throw new Error("Values are missing")
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const employee = await getEmployeeReference({
      employeeNumber: user.employeeNumber,
      sanityClient: client,
    })

    const updatedDefects = (await getDefectReferences(client, values?.defects)) || []
    const updatedApplications = (await getApplicationReferences(client, values?.applications)) || []
    const updateClaims = (await getClaimReferences(client, values?.customerClaims)) || []
    const updatedAttachmentReferences = getAttachmentReferences(values?.attachmentReferences) || []

    const doc = {
      ...values,
      _type: "complaint",
      creationAt: todaysDate,
      modifiedAt: todaysDate,
      defects: updatedDefects,
      applications: updatedApplications,
      customerClaims: updateClaims,
      attachmentReferences: updatedAttachmentReferences || [],
      modificationSource: "Sanity",
      ...(employee && { creationBy: employee, modifiedBy: employee }),
    }

    try {
      const insertComplaint = await client.create(doc)

      if (!insertComplaint) return null

      if (insertComplaint) {
        return {
          ...insertComplaint,
          id: insertComplaint._id,
          rev: insertComplaint._rev,
        }
      }
    } catch (error) {
      throw new Error(error.message)
    }

    return null
  },
}
